/*
 *  -----------------------------------------------------------------------
 *    <copyright file="shared.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import Constants from './constants';
import { ReportStatusUpdatedFields } from '@interfaces-clean/reports.interface';

export const checkValidity = (value: any, rules: any) => {
    let isValid = true;
    if (!rules) return true;

    if (rules.required) isValid = value.trim() !== '' && isValid;

    if (rules.minLength) isValid = value.length >= rules.minLength && isValid;

    if (rules.maxLength) isValid = value.length <= rules.maxLength && isValid;

    if (rules.isEmail) {
        const pattern =
            /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        isValid = pattern.test(value) && isValid;
    }

    if (rules.isNumeric) {
        const pattern = /^\d+$/;
        isValid = pattern.test(value) && isValid;
    }

    return isValid;
};

export const findAtLeastOneTrueValue = (object: any) =>
    !!Object.keys(object).find((key: string) => object[key] === true);

export const getFieldName = (type: number, field: string) => {
    if (
        type === Constants.FieldDefinitionFieldTypes.BOOL ||
        type === Constants.FieldDefinitionFieldTypes.DATE ||
        type === Constants.FieldDefinitionFieldTypes.FLOAT
    )
        return `_${field}`;
    if (type === Constants.FieldDefinitionFieldTypes.PARTIAL_DATE) return `_${field}.time`;
    return field;
};

export const titleCase = (str: string | number) => {
    if (typeof str === 'string') {
        const splitStr = str.toLowerCase().split(' ');
        for (let i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(' ');
    }

    return str;
};

export const isReportStatusUpdated = <T extends { id?: string }>(
    reports: T[],
    publishedReport: ReportStatusUpdatedFields,
) => reports.find((item) => publishedReport.reportId === item.id);
